
  export default {
    layout: 'mainPage',
    transition: 'page',
    head() {
      return {
        title: `${this.$t('contact.title')} - ICDC`
      }
    }
  }
